import React, { useContext, useEffect, useState } from 'react';

const QueriesReachOut = (props) => {
    if(props.visible){
        return (
            <div id="login-privacy-policy-link" style={{display:"flex", justifyContent:"center", color:"#6B6B6B", fontFamily:"pf_handbook_proregular", fontWeight:"400", margin: "5px",}}>
                For queries, reach out to us at &nbsp;
                <a
                    href="mailto:Care.digitalfinance@adityabirlacapital.com"
                    style={{backgroundColor: "none", color:"#5D90F3", textDecoration:"none"}}
                >
                    Care.digitalfinance@adityabirlacapital.com
                </a>
            </div>
        );
    }
    else {
        return <></>;
    }
};

export default QueriesReachOut;